import { render, staticRenderFns } from "./ReferralTypeEditor.vue?vue&type=template&id=7a8c771f&scoped=true"
import script from "./ReferralTypeEditor.vue?vue&type=script&lang=js"
export * from "./ReferralTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8c771f",
  null
  
)

export default component.exports